import React, {useState, useEffect} from 'react'
import {MyStore} from '../../../../services/Store'
// import { withRouter } from 'react-router-dom';
// import PropTypes from 'prop-types';
import Groups from '../groups/Groups'

 
// import Messages from '../messages/Messages'
// import UserCardsMessage from '../messages/UserCardsMessage'



import { Container, Message, Search, Card, Sidebar, Menu, Icon, Grid, Image, Segment, Header, Button } from 'semantic-ui-react'
const UserOrgans= () =>{

    
    const [state, setState] = useState({
        animation: 'push',
        direction: 'left',
        dimmed: false,
        visible: false,
        // activeConvoId: "-LwLujWwcsr6szQxZYer",
        activeConvoId: null,
      })
      const [currentGroup, setCurrentGroup] = useState({})
      const [members, setMembers] = useState()
    // this.state = {
    //     animation: 'push',
    //     direction: 'left',
    //     dimmed: false,
    //     visible: false,
    //   }
    // const recipeKey = '-LwLujWwcsr6szQxZYer';
    // props.match.params.id;
    // const recipeKey = '-LwLujWwcsr6szQxZYer';
    const recipeKey = ''
    let cg = []

    let user = MyStore.auth().currentUser
    // console.log(user)
    let displayName = ''
    let avatar = ''
 
    // "-LwLujWwcsr6szQxZYer"

    // "-LwLokoEOlo2jFZHUsDJ"

    if (user) {
        displayName = user.displayName
        avatar = user.photoURL
    }


   const changeGroup = group => {
    // const groups = MyStore.database().ref("groups").child('-LwLokoEOlo2jFZHUsDJ')
    // console.log('----------- groups  current group -------------')
    // console.log(groups)
    // console.log(currentGroup)
    setCurrentGroup(group);
    // return groups
        // const { setCurrentGroup } = this.props;
        // setCurrentGroup(group);
        // this.setActiveConvoId(group.id);
        // this.clearNotifications();

    };


    useEffect(() => {


        // MyStore.auth().onAuthStateChanged((user) => {
        //     if (user) {

        //         MyStore.database().ref().child(`/groups/${recipeKey}`).on('value', snap => {
        //             // let groups = []
        //             console.log(snap.val())
        //             // cg = snap.val()
        //             setCurrentGroup((snap.val()))


        //             // let length = Object.keys(currentGroup.members).length

        //             let myArr = []

        //             for (const key in snap.val().members) {
        //                 myArr.push(Object.assign({}, snap.val().members[key]));
        //             }
        //             if (snap.val() != null) {
        //                 // users = myArr
        //                 cg = myArr
        //                 setMembers(cg)
        //                 // setState({myArr})
        //             }
        //             // else {
        //             //   this.setState({
        //             //     groups: []
        //             //   })    
        //             // }

        //         });




        //         // console.log(cg)


        //         let authMembers = []
        //         for (let item in cg) {
        //             console.log(cg[item].username)
        //             MyStore.database().ref().child(`/usernames/${cg[item].username}`).on('value', snap => {
        //                 console.log(snap.val())
        //                 authMembers.push(snap.val())
        //             })

        //             // authMembers.push(MyStore.ref().child("usernames").child(cg[item].username))
        //             // console.log(item)
        //         }

        //     }

        // })



    }, []);

    


    const UserData = () => (
        <div  style={{     marginTop:'5vh', width:'50vh'}}>
       
           
                <Header as='h1'  style={{  width:'center', float:'center', minWidth: '50vh' }}>
                            {/* <Icon name='user' /> */}
                            <Image src={avatar} />
                            <Header.Content>
                                <Header.Subheader> <h1>Loading</h1></Header.Subheader>
                          <p>{'' || displayName}</p>
                            </Header.Content>
                        </Header>

              
                {/* <Grid columns={3} >

      
                    <Grid.Column width='100vh'>
                        <Header as='h1'  >
                       
                            <Image src={avatar} />
                            <Header.Content>
                                <Header.Subheader> <b>Profile</b></Header.Subheader>
                                {'' || displayName}
                            </Header.Content>
                        </Header>
                    </Grid.Column>
 
                </Grid> */}

 
        </div>
    )

 
    return(
        <React.Fragment>
            <Container>

            {/* <Header>Profile</Header> */}



      <div>

      {/* {UserData()} */}

        {/* {this.SegmentPadded()} */}

        {/* {this.HeaderExampleSettingsIcon()} */}

      
            {/* <Segment basic>
              <Header as='h3'>Application Content</Header>
              <Image src='https://react.semantic-ui.com/images/wireframe/paragraph.png' />
            </Segment> */}

            <div style={{marginTop:'5vh'}}>
            <h1 style={{margin:'justified'}}> Cadre</h1>
              {/* {this.imageGetter()} */}


              


<Groups
                    currentUser={MyStore.auth().currentUser}
                    currentGroup={currentGroup}
                    activeConvoId={state.activeConvoId}
                    changeGroup={changeGroup}
                    // addNotificationListener={this.addNotificationListener}
                    // notifications={notifications}
                />

            </div>

            {/* <Grid columns={3} divided>
              <Grid.Column>
                <Image src='https://react.semantic-ui.com/images/wireframe/media-paragraph.png' />
              </Grid.Column>
              <Grid.Column>
                <Image src='https://react.semantic-ui.com/images/wireframe/media-paragraph.png' />
              </Grid.Column>
              <Grid.Column>
                <Image src='https://react.semantic-ui.com/images/wireframe/media-paragraph.png' />
              </Grid.Column>
            </Grid> */}

            <Message style={{
                background: "transparent",
                border: "1px solid transparent",
                boxShadow: "none",
                padding: "0em 0em",
            }}
            ></Message>

            {/* <Messages
                // key={MyStore.database().ref("groups").child("-LwLokoEOlo2jFZHUsDJ") && "-LwLokoEOlo2jFZHUsDJ"}
                key={currentGroup.id}
                currentGroup={currentGroup}
                currentUser={MyStore.auth().currentUser}
                isDM={false}
                /> */}

            {/* <Segment basic>
              <Header as='h3'>Application Content</Header>
              <Image src='https://react.semantic-ui.com/images/wireframe/paragraph.png' />
            </Segment>


            <Segment basic>
              <Header as='h3'>Application Content</Header>
              <Image src='https://react.semantic-ui.com/images/wireframe/paragraph.png' />
            </Segment>


            <Segment basic>
              <Header as='h3'>Application Content</Header>
              <Image src='https://react.semantic-ui.com/images/wireframe/paragraph.png' />
            </Segment>


            <Segment basic>
              <Header as='h3'>Application Content</Header>
              <Image src='https://react.semantic-ui.com/images/wireframe/paragraph.png' />
            </Segment> */}

  


            </div>



            </Container>

            
        </React.Fragment>

    )


}
 
// 
// export default withRouter(UserOrgans)
export default UserOrgans